// extracted by mini-css-extract-plugin
export default {"root":"styles_root__N1bcb","content":"styles_content__0qb7v","footText":"styles_footText__AO7IP"};